exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-tabs-style2[data-v-0b451610]{position:fixed;top:10px;right:10px;width:780px;background-color:#fff;z-index:2}.fix-height[data-v-0b451610]{height:40px;width:100%}", ""]);

// exports
